import { LoanPartnerCommunicationOverviewPage } from '@interhyp/module-credit-communication';
import React, { useMemo } from 'react';

import { Navigation, NavItems } from '../../navigation/Navigation';

export interface SubmissionCommunicationOverviewLegacyWrapperProps {
  submissionId: string;
}

export function SubmissionCommunicationOverviewLegacyWrapper({
  submissionId,
}: SubmissionCommunicationOverviewLegacyWrapperProps): JSX.Element {
  const navigationItems: NavItems = useMemo(() => {
    return [
      { to: `/credit/summary`, translation: 'navigation.summary' },
      { to: `/credit/documents`, translation: 'navigation.documents' },
      {
        to: `/credit/communication`,
        translation: 'navigation.communication',
      },
    ];
  }, []);

  return (
    <>
      <Navigation navItems={navigationItems} />
      <LoanPartnerCommunicationOverviewPage aggregateId={submissionId} resourceType="SUBMISSION" />
    </>
  );
}
